import { getEnvLink } from './routes';

/**
 * Generates a canonical URL by removing query parameters and fragments
 * @param path - The current path (e.g., '/athlete/merch')
 * @returns Clean canonical URL without query parameters
 */
export const getCanonicalUrl = (path: string): string => {
  // Remove query parameters and hash fragments
  const cleanPath = path.split('?')[0].split('#')[0];

  // Ensure no trailing slash (except for homepage)
  const normalizedPath = cleanPath === '/' ? '/' : cleanPath.replace(/\/$/, '');

  return `${getEnvLink()}${normalizedPath}`;
};
